import { Navigate, useLocation } from "react-router-dom";
import { readAdminSession } from "utils/adminSession";

const ADMIN_LOGIN_PATH = "/admin/login";

export default function RequireAdmin({ children }) {
  const location = useLocation();
  const session = readAdminSession();

  if (!session) {
    const from =
      location.pathname === "/admin" || location.pathname === "/admin/"
        ? "/admin/default"
        : `${location.pathname}${location.search}${location.hash}`;
    return (
      <Navigate
        to={ADMIN_LOGIN_PATH}
        state={{ from }}
        replace
      />
    );
  }

  return children;
}